module.exports = __webpack_public_path__ + "static/media/the-athlete.bebf6bde.png";